import { useState } from "react";
import BgLinkButton from "../Buttons/BgLinkButton";

const HoverDropdownButton = ({
  className,
  children,
  options,
  dropdownClasses,
  displayOnClick = false,
}) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      className="relative z-[5] py-1 h-auto sm:h-12"
      onClick={() => {
        if (displayOnClick) setHover((prev) => !prev);
      }}
      onMouseEnter={() => {
        if (!displayOnClick) setHover(true);
      }}
      onMouseLeave={() => {
        if (!displayOnClick) setHover(false);
      }}
    >
      <button
        className={`rounded-full py-2 px-4 font-normal dark:hover:text-dark_primary_label dark:text-dark_secondary_label text-light_secondary_label hover:text-light_primary_label dark:hover:bg-dark_bg_grey hover:bg-light_bg_grey outline-none text-nowrap ${className}`}
        name="btn"
      >
        {children}
      </button>

      {hover && (
        <div
          className={`absolute top-11 flex flex-col min-w-44  max-w-64 dark:bg-custom_black bg-white p-1 drop-shadow-xl rounded-xl ${hover ? "flex" : "hidden"
            } ${dropdownClasses}`}
          onMouseEnter={() => setHover(true)}
        >
          {options?.map((opt, ind) => (
            <BgLinkButton
              key={ind}
              icon={opt?.icon}
              link={opt?.link}
              setHover={setHover}
              onClick={opt?.onClick}
              isHidden={opt?.isHidden}
            >
              {opt?.label}
            </BgLinkButton>
          ))}
        </div>
      )}
    </div>
  );
};

export default HoverDropdownButton;
